import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Create a new address for a customer
 * @param {Object} addressData - Address data to be sent to the API
 * @returns {Promise<Object>} - Response data from the API
 */
export const createCustomerAddress = async (addressData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.CREATE_NEW_ADDRESS, addressData);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Update an existing customer address
 * @param {Object} addressData - Updated address data
 * @param {string|number} addressId - ID of the address to update
 * @returns {Promise<Object>} - Response data from the API
 */
export const updateCustomerAddress = async (addressData, addressId) => {
  try {
    // Replace ':addressId' in the endpoint with the actual addressId
    const endpoint = API_ENDPOINTS.UPDATE_ADDRESS.replace(':addressId', addressId);
    const response = await apiClient.put(endpoint, addressData);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

